import React from "react";
import { Html } from "react-konva-utils";
import Button from "@mui/material/Button";
import { ThemeProvider } from "@mui/material";
import DevelopTheme from "../DevelopTheme.js";

function ContextMenu({ x, y, options }) {
  return (
    <Html
      divProps={{
        style: {
          position: "absolute",
          top: y + 3 + "px",
          left: x + 3 + "px",
        },
        className: "menu",
      }}
    >
      <ThemeProvider theme={DevelopTheme}>
        <div onContextMenu={(e) => e.preventDefault()}>
          {options.map((option) => {
            return (
              <Button
                sx={{ borderRadius: 0, boxShadow: 0 }}
                size={"small"}
                color={option.disabled ? "contextMenuButtonDisabled" : "contextMenuButton"}
                variant="contained"
                key={option.name}
                onClick={option.func}
                disabled={option.disabled}
                style={{ display: "flex" }}
              >
                <div className="contextIcon" style={{ alignSelf: "center" }}>
                  {option.icon}
                </div>
                <div className="contextItemName" style={{ alignSelf: "center" }}>
                  {option.name}
                </div>
              </Button>
            );
          })}
        </div>
      </ThemeProvider>
    </Html>
  );
}

export default ContextMenu;
